import React, { Component } from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { Field } from 'redux-form';
import ReactDataGrid from 'react-data-grid';
import { Data, CheckboxEditor } from 'react-data-grid-addons';
import { InputField } from '../Common/inputField';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input } from 'react-bootstrap';
import Spinner from '../../components/Widgets/spinner';
import FilterByStart from '../Common/filterByStart';
import { Translate, Localize } from 'react-redux-i18n';
import { isOLG } from '../../actions/root_url';

class RowRenderer extends Component {

    PropTypes: {
      onDoubleClick: React.PropTypes.func
    };

    render() {
        return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

let renderTypeRadios = props => {
    return (
        <div className="form-group" id="search-product-by">
          <label className="col-sm-3 search-by-max-width">
            <Translate value="search_by" />
          </label>
          <label className="col-sm-2" >
              <input {...props.input} type="radio" value="ProductNum"
                checked={props.input.value === "ProductNum"}/>
              <Translate value="prod_num" />
          </label>
          <label className="col-sm-2 pl">
            <input {...props.input} type="radio" value="RefNum"
              checked={props.input.value === "RefNum"}/>
            <Translate value={isOLG ? "item_no" : "ref_num"} />
          </label>
          <label className="col-sm-2" >
              <input {...props.input} type="radio" value="Name"
                checked={props.input.value === "Name"}/>
              <Translate value="name" />
          </label>
          <label className="col-sm-3" >
              <input {...props.input} type="radio" value="Description"
                checked={props.input.value === "Description"}/>
              <Translate value="description" />
          </label>
        </div>
    )
}

class PurchasePivotChartSearchProd extends Component {
  constructor() {
    super();
    this.state = {
      products: {
        rows: [],
        selectedRows: [],
        sortColumn: null,
        sortDirection: null,
      }
    }
    this.showProducts = this.showProducts.bind(this);
  }
  componentWillMount() {
    this.props.setDefaultOfForm("SearchType", "RefNum", "purchasePivotChartSearchProd")
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.simplifiedProducts && nextProps.simplifiedProducts != this.props.simplifiedProducts) {
      let products = {...this.state.products, rows: nextProps.simplifiedProducts}
      this.setState({products})
    }
  }
  showProducts(event) {
    if(!(this.props.searchType) || !(this.props.searchValue) || (this.props.searchValue==""))
      return;
    switch (event.charCode) {
        case 13: // ENTER
            event.preventDefault();
            this.props.fetchSimplifiedProducts(this.props.searchType, this.props.searchValue);
            break;
    }
  }
  renderTable() {
      if (this.props.simplifiedProductsIsLoading && !this.props.simplifiedProductsError) return <Spinner/>
      else if (this.props.simplifiedProductsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.simplifiedProductsError)}</div></ContentWrapper>
      else {
          // Parameters of the react-data-grid

          const getRows = () => {
              return Data.Selectors.getRows(this.state.products);
          }

          const getSize = () => {
              return getRows().length;
          }

          const rowGetter = rowIdx => {
              var rows = getRows();
              return rows[rowIdx];
          }

          // Handle the sortable function

          const handleGridSort = (sortColumn, sortDirection) => {
              var products = Object.assign({}, this.state.products, { sortColumn: sortColumn, sortDirection: sortDirection });
              this.setState({products});
          }

          // Column difinition

          const columns = [
            {
                key: 'ProductNum',
                name: <Translate value="prod_num" />,
                resizable: true,
                sortable: true,
                width: 80,
                filterRenderer: FilterByStart,
            },
            {
                key: 'RefNum',
                name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
                resizable: true,
                sortable: true,
                width: 70,
                filterRenderer: FilterByStart,
            },
            {
                key: 'Name',
                name: <Translate value="prod_name" />,
                resizable: true,
                sortable: true,
                width: 200,
            },
            {
                key: 'Description',
                name: <Translate value="description" />,
                resizable: true,
                sortable: true,
            },
          ]

          return (
              <Row><Col sm={ 12 }><div style={{ maxWidth: '100%' }} id="PurchasePivotChartSearchProd-dataGrid1">
                  <ReactDataGrid
                      rowRenderer={<RowRenderer onDoubleClick={this.props.selectProduct} />}
                      rowKey='Product_id'
                      rowHeight={25}
                      minHeight={400}
                      onGridSort={handleGridSort}
                      columns={columns}
                      rowGetter={rowGetter}
                      rowsCount={getSize()}
                      enableCellSelect={true}
                  />
              </div></Col></Row>
          )
      }
  }
  render() {
    return (
      <ContentWrapper>
        <Row>
          <Field name="SearchType" component={ renderTypeRadios } />
        </Row>
        <br/>
        <Row>
          <Col md={ 4 }>
            <Field name="SearchValue" component={ InputField } onKeyPress={(event) => {this.showProducts(event)}} onFocus={this.handleOnFocus} placeholder="search"/>
          </Col>
        </Row>
        <br/>
        <Row>
          { this.renderTable() }
        </Row>
      </ContentWrapper>
    )
  }
}

export default PurchasePivotChartSearchProd;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchasePivotChartSearchProd.jsx